import { Elements } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import TakePaymentsCheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import { toast } from "react-toastify";
import { ApiURL } from "../../helpers/APIdata/apiURL";
import * as apiURL from "../../helpers/APIdata/apiURL";
import { isEmpty } from "lodash";
const StripeTakePayments = ({
  callBackAfterPaymentSuccess,
  CallBackAfterPaymentError,
  PaymentMethod_Id,
  bodyToSend,
  loading,
  token,
  buttonLabel = "Pay & Place Order",
  fullWidthButton = true,
  allowedPaymentMethods = null, // e.g., ['card'] to hide Link and others; omit to show defaults
  stripeData = null, // if you already have a PaymentIntent client_secret and Stripe PK, provide them here to skip the fetch
  ecommerceStrict = false,
}) => {
  const [cardStorageOptions, setCardStorageOptions] = useState(1); // 1 = Save + Default, 2 = Save only, 3 = Onetime use only

  const [dpmCheckerLink, setDpmCheckerLink] = useState("");
  const [stripePromiseAPI, setStripePromiseAPI] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const stripePromise =
    stripePromiseAPI !== null && loadStripe(stripePromiseAPI);

  // NEW: gate the submit button so users can't submit before a method is selected
  const [submitting, setSubmitting] = React.useState(false);
  const [peReady, setPeReady] = React.useState(false);
  const [peComplete, setPeComplete] = React.useState(false);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret: clientSecret || stripeData?.client_secret,
    appearance,
    ...(Array.isArray(allowedPaymentMethods) && allowedPaymentMethods.length
      ? { paymentMethodOrder: allowedPaymentMethods } // explicit from caller
      : ecommerceStrict
      ? { paymentMethodOrder: ["card"] } // default to card-only in ecommerce
      : {}),
  };

  const [amountToCharge, setAmountToCharge] = useState(null);
  const authUser = JSON?.parse(localStorage?.getItem("authUser"));

  const handleGetStipeSecret = () => {
    // if (!PaymentMethod_Id) return;
    if (!bodyToSend) return;
    // console.log(
    //   "https://api2.crmit.co.uk/ci-4-jwt/public/foodpreordereventguesttofoodmenuitem/create/preauth"
    // );

    fetch(
      `${
        apiURL.ApiURL().API_URL
      }/foodpreordereventguesttofoodmenuitem/create/preauth`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...(token && { "x-token-key": token }),
          ...(!token && { Authorization: `Bearer ${authUser?.token}` }),
        },
        body: JSON?.stringify(bodyToSend),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.status !== 200) {
          CallBackAfterPaymentError(data);
        }
        if (data?.amount === "0") {
          callBackAfterPaymentSuccess();
          return;
        }
        if (!data.client_secret || !data?.stripe_pk || !data?.amount) {
          let response = {
            message:
              "Error: Something went wrong, please try again later if problem persist contact support",
          };
          CallBackAfterPaymentError(response);
        }
        setClientSecret(data.client_secret);
        setStripePromiseAPI(data?.stripe_pk);
        setAmountToCharge(data?.amount);
      });
  };

  useEffect(() => {
    if (!isEmpty(stripeData)) {
      setClientSecret(stripeData?.client_secret);
      setStripePromiseAPI(stripeData?.stripe_pk);
      setAmountToCharge(stripeData?.amount);
    } else {
      handleGetStipeSecret();
    }
    return () => {
      setClientSecret("");
    };
  }, []);

  return (
    <div>
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={options}>
          <TakePaymentsCheckoutForm
            callBackAfterPaymentSuccess={callBackAfterPaymentSuccess}
            loading={loading}
            amountToCharge={amountToCharge}
            buttonLabel={buttonLabel}
            fullWidthButton={fullWidthButton}
            ecommerceStrict={ecommerceStrict}
          />
        </Elements>
      )}
    </div>
  );
};

export default StripeTakePayments;
